import React, { useState, Fragment } from 'react';
import { Box, Button, Form, FormField, Heading, Text } from 'grommet';
import { withFirebaseConsumer } from 'components/common/Firebase';
// import PropTypes from 'prop-types' // TODO!!!: proptypes
import { compose } from 'recompose';
import { addNotification } from 'AppEntry';

const ResetPasswordBase = props => {
  const initialState = {
    password: null,
    confirmation: null
  };

  const [state, setState] = useState(initialState);

  const handleChange = event => {
    setState({
      ...state,
      [event.target.name]: event.target.value
    });
  };

  const resetPassword = async (oobCode, password, confirmation) => {
    console.log(state);
    try {
      if (confirmation !== password)
        throw new Error('Your passwords do not match.');
      await props.firebase.doConfirmPasswordReset(oobCode, password);
      addNotification(
        'Success!',
        'Your password was reset. Please sign in!',
        'success'
      );
    } catch (error) {
      console.log(error);
      addNotification('Error!', error.message, 'error');
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
    resetPassword(props.oobCode, state.password, state.confirmation);
  };

  return (
    <Fragment>
      <Box
        direction="row"
        height="large"
        margin={{ top: 'xlarge' }}
        pad="medium"
      >
        <Box basis="full" pad="small">
          <Box alignSelf="center" elevation="small" pad="small">
            <Heading alignSelf="center" color="brand" level="2">
              reset password
            </Heading>
            <Form
              onChange={event => {
                handleChange(event);
              }}
              onSubmit={event => {
                handleSubmit(event);
              }}
            >
              <Box align="center">
                <FormField
                  type="password"
                  name="password"
                  label="new password"
                  required={true}
                  //validate={ (value, values) => { } }
                />
                <FormField
                  type="password"
                  name="confirmation"
                  label="password confirmation"
                  required={true}
                  //validate={{ regexp: /^[a-z]/i }}
                />
                <Button
                  label={<Text>reset password</Text>}
                  margin={{ bottom: 'small', top: 'small' }}
                  primary={true}
                  type="submit"
                />
              </Box>
            </Form>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export const ResetPassword = compose(withFirebaseConsumer)(ResetPasswordBase);
